export default __webpack_public_path__ + "static/media/profile-password-icon.fd6fa2f4.svg";